import React from 'react';
import CustomTable from '../table/table';
import InvoiceSummaryCards from '../invoice-summary-cards';

/**
 * InvoiceClaimsPanel
 *
 * A fully reusable presentational component that renders:
 *   1. Three financial summary cards  (Total Claimed / Retention / Approved)
 *   2. A claims listing table with an optional summary row
 *
 * The parent page is responsible for:
 *   - Computing card values (claimed, retention, approved)
 *   - Defining column shapes (including action menus)
 *   - Building the data array (with isSummary row appended if needed)
 *
 * Props:
 *   claimed        {string}  — Pre-formatted Total Amount Claimed  (e.g. "$1,200.00")
 *   retention      {string}  — Pre-formatted Total Retention
 *   approved       {string}  — Pre-formatted Amount Approved
 *   columns        {Array}   — CustomTable column definitions (title, field, render …)
 *   data           {Array}   — Row data including any trailing summary row
 *   exportButton   {bool}    — Show export button in table toolbar  (default: false)
 *   enableSearch   {bool}    — Show search input in table toolbar   (default: false)
 *   toolbar        {bool}    — Show table toolbar                   (default: false)
 *   fileName       {string}  — Export file name                     (default: "Claims")
 *   dataCy         {string}  — data-cy attribute on the table
 */
const InvoiceClaimsPanel = ({
  // Card props
  claimed,
  retention,
  approved,

  // Table props
  columns = [],
  data = [],

  // Table config
  exportButton = false,
  enableSearch = false,
  toolbar = false,
  fileName = 'Claims',
  dataCy = 'claims-table',
}) => {
  return (
    <>
      {/* Summary Cards */}
      <InvoiceSummaryCards
        claimed={claimed}
        retention={retention}
        approved={approved}
      />

      {/* Claims Table */}
      <div className="claims-section">
        <CustomTable
          columns={columns}
          data={data}
          isAction={false}
          exportButton={exportButton}
          fileName={fileName}
          enableSearch={enableSearch}
          toolbar={toolbar}
          dataCy={dataCy}
        />
      </div>
    </>
  );
};

export default InvoiceClaimsPanel;
